var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 16,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.836 11H2v-1H1v-.836l.71-.71 1.837 1.835-.711.711Zm4.086-7.25a.183.183 0 0 1-.055.133L2.633 8.117a.183.183 0 0 1-.133.055A.164.164 0 0 1 2.328 8c0-.047.016-.094.055-.133l4.234-4.234a.183.183 0 0 1 .133-.055c.102 0 .172.07.172.172ZM6.5 2.25 0 8.75V12h3.25l6.5-6.5L6.5 2.25Zm5.336.75c0-.266-.11-.523-.29-.71L9.712.46A1.012 1.012 0 0 0 9 .165a.98.98 0 0 0-.703.297L7 1.75 10.25 5l1.297-1.297c.18-.18.289-.437.289-.703Z",
  fill: "#D1D3DA"
})));
export { SvgPencil as ReactComponent };
export default __webpack_public_path__ + "cf195952a8702fab00bcf9aaea018f15.svg";